/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { AsReportedIssuer } from '../models/as-reported-issuer';
@Injectable({
  providedIn: 'root',
})
class AsReportedIssuerService extends __BaseService {
  static readonly getAsReportedIssuerByNamePath = '/as-reported-issuer/search-by-name';
  static readonly getAsReportedIssuerByCikPath = '/as-reported-issuer/search-by-cik';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param asReportedIssuerName undefined
   * @return get as reported issuer according to name
   */
  getAsReportedIssuerByNameResponse(asReportedIssuerName: string): __Observable<__StrictHttpResponse<Array<AsReportedIssuer>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (asReportedIssuerName != null) __params = __params.set('asReportedIssuerName', asReportedIssuerName.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/as-reported-issuer/search-by-name`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AsReportedIssuer>>;
      })
    );
  }
  /**
   * @param asReportedIssuerName undefined
   * @return get as reported issuer according to name
   */
  getAsReportedIssuerByName(asReportedIssuerName: string): __Observable<Array<AsReportedIssuer>> {
    return this.getAsReportedIssuerByNameResponse(asReportedIssuerName).pipe(
      __map(_r => _r.body as Array<AsReportedIssuer>)
    );
  }

  /**
   * @param asReportedIssuerCik undefined
   * @return get as reported issuer according to cik
   */
  getAsReportedIssuerByCikResponse(asReportedIssuerCik: string): __Observable<__StrictHttpResponse<Array<AsReportedIssuer>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (asReportedIssuerCik != null) __params = __params.set('asReportedIssuerCik', asReportedIssuerCik.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/as-reported-issuer/search-by-cik`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AsReportedIssuer>>;
      })
    );
  }
  /**
   * @param asReportedIssuerCik undefined
   * @return get as reported issuer according to cik
   */
  getAsReportedIssuerByCik(asReportedIssuerCik: string): __Observable<Array<AsReportedIssuer>> {
    return this.getAsReportedIssuerByCikResponse(asReportedIssuerCik).pipe(
      __map(_r => _r.body as Array<AsReportedIssuer>)
    );
  }
}

module AsReportedIssuerService {
}

export { AsReportedIssuerService }
